<div
  *ngIf="media && media.length > 0"
  class="media-preview-grid"
  cdkDropListGroup
>
  <div
    *ngFor="let mediaObj of media; let index = index"
    class="grid-drop-list"
    cdkDropList
    cdkDropListOrientation="horizontal"
    [cdkDropListData]="index"
    (cdkDropListDropped)="drop($event)"
  >
    <div cdkDrag class="drag-element">
      <div class="tile-image">
        <img class="tile-image" [ngSrc]="mediaObj.src" fill />
      </div>
      <button
        class="bl-fab"
        mat-icon-button
        aria-label="icon button with a trash icon"
        (click)="editMedia(index)"
      >
        <mat-icon>edit</mat-icon>
      </button>
      <button
        class="br-fab"
        color="warn"
        mat-icon-button
        aria-label="icon button with a trash icon"
        (click)="removeMedia(index)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</div>
